import { z } from "zod";
import * as themeScheme from "@ecp-redux/dto/themeSettings/themeSettings.schemes";

export const BoxShowPageMessagesScheme = z.object({});

export const BoxShowPageSettingsScheme = z.object({
  url: themeScheme.UrlScheme.default(""),
});
